import { get, post } from  "@/utils/request";
// 分页获取商户列表(商户号)
export const getMerchantUserListPage = data => post('merchant_user/getMerchantUserListPage', data);
//修改商户信息
export const updateMerchantUser = data => post('merchant_user/updateMerchantUser', data);
// 查询打印机详情
export const getByMerchantCoding = data => post('print/getByMerchantCoding', data);
// 编辑打印机
export const editPrint = data => post('print/editPrint', data);
//获取所有商户
export const getDogsTenantPageList = data => post('merchant_user/getDogsTenantPageList', data);



// WEBPACK FOOTER //
// ./src/api/merchant.js